import {RemoteGetFacialBiometricIdentification} from 'data/usecases/others/facial-biometric';
import {GetFacialBiometricIdentification} from 'domain/usecases/others/facial-biometric';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {FacialBiometricEndpoints} from '../../endpoints';

export const makeGetFacialBiometricIdentification = (): GetFacialBiometricIdentification =>
	new RemoteGetFacialBiometricIdentification(
		makeBFFApiUrl(FacialBiometricEndpoints.identification),
		makeAuthorizeHttpClientDecorator(),
	);
